const PATH = 'app/NavBar';

export const SAVE_IS_SIDE_BAR_STATUS = `${PATH}SAVE_IS_SIDE_BAR_STATUS`;
export const SAVE_ACTIVE_ROUTE = `${PATH}SAVE_ACTIVE_ROUTE`;